

const ContainerCover = props => {
    return (
        <div className="sdg-report-cover">
            <div className="title-holder">
                { props.social ? renderSocial() : '' }
                <h1 className="title-report">{ props.title }</h1>
                <h2>{ props.subtitle }</h2>
                { props.sdg ? renderSdgIcons(props.sdgIcon1, props.sdgIcon2, props.sdgIcon5, props.sdgIcon6, props.sdgIcon10, props.sdgIcon12, props.sdgIcon14, props.sdgIcon15) : '' }
            </div>
        </div>
    ) 
}

const renderSocial = () => {
    return(
        <div className="social-share social-mobile d-flex">
            <a href="http://www.facebook.com/share.php?u=http://www.fao.org/sdg-progress-report/2021/es/" target="_blank" rel="noreferrer" className="social-a">
                <span className="facebook-icon-sec"></span>
            </a>
            <a href="https://twitter.com/intent/tweet?text=Tracking progress on food and agriculture-related SDG indicators 2021. A report on the indicators under FAO custodianship." target="_blank" rel="noreferrer" className="social-a">
                <span className="twitter-icon-sec"></span>
            </a>
            <a href="https://www.linkedin.com/shareArticle?mini=true&amp;url=http%3A//www.fao.org/sdg-progress-report/2021/es/" target="_blank" rel="noreferrer" className="social-a">
                <span className="linkedin-icon-sec"></span>
            </a>
            <a href={getDownloadLink()} className="btn btn-secondary btn-sm btn-download-pdf" target="_blank" rel="noreferrer">
            {getTextTranslation()}</a>
        </div>
    );
}

const getDownloadLink = () => {
    const l = document.getElementsByTagName('html')[0].getAttribute('lang');

    switch(l) {
        case 'en':
            return 'https://www.fao.org/3/cb6872en/cb6872en.pdf';
        case 'es':
            return 'https://www.fao.org/3/cb6872es/cb6872es.pdf';
        case 'fr':
            return 'https://www.fao.org/3/cb6872fr/cb6872fr.pdf';
        // case 'zh':
        //     return 'https://www.fao.org/3/cb6872zh/cb6872zh.pdf';
        // case 'ru':
        //     return 'https://www.fao.org/3/cb6872ru/cb6872ru.pdf';
        // case 'ar':
        //     return 'https://www.fao.org/3/cb6872ar/cb6872ar.pdf';
        default:
            return 'https://www.fao.org/3/cb6872en/cb6872en.pdf';
    }
}

const getTextTranslation = () => {
    const l = document.getElementsByTagName('html')[0].getAttribute('lang');

    switch(l) {
        case 'en':
            return 'Download PDF';
        case 'es':
            return 'Descargar PDF';
        case 'zh':
            return '下载PDF文件';
        case 'ru':
            return 'Скачать PDF';
        case 'ar':
            return 'قم بتنزيل الملف PDF';
        case 'fr':
            return 'Télécharger le PDF';
        default:
            return 'Download PDF';
    }
}

const renderSdgIcons = (icon1, icon2, icon5, icon6, icon10, icon12, icon14, icon15) => {
    return(
        <div className="sdg-report-cover-icons">
            <img onClick={onClickSlideTo} src={icon1} alt="SDG 1 Target" rel="1" id="btn-sdg-1-cover" />
            <img onClick={onClickSlideTo} src={icon2} alt="SDG 2 Target" rel="2" id="btn-sdg-2-cover" />
            <img onClick={onClickSlideTo} src={icon5} alt="SDG 5 Target" rel="3" id="btn-sdg-5-cover" />
            <img onClick={onClickSlideTo} src={icon6} alt="SDG 6 Target" rel="4" id="btn-sdg-6-cover" />
            <img onClick={onClickSlideTo} src={icon10} alt="SDG 10 Target" rel="5" id="btn-sdg-10-cover" />
            <img onClick={onClickSlideTo} src={icon12} alt="SDG 12 Target" rel="6" id="btn-sdg-12-cover" />
            <img onClick={onClickSlideTo} src={icon14} alt="SDG 14 Target" rel="7" id="btn-sdg-14-cover" />
            <img onClick={onClickSlideTo} src={icon15} alt="SDG 15 Target" rel="8" id="btn-sdg-15-cover" />
        </div>
    );
}

const onClickSlideTo = e => { 
    const swiper = document.querySelector('.sdg-swiper').swiper;
    let id = e.target.getAttribute('rel');
    swiper.slideTo(id);
}
  


export default ContainerCover;
